export default class ChatMessage {
    constructor({ role, content, threadId = null, timestamp = new Date().toISOString() }) {
      this.role = role; // 'user' or 'assistant'
      this.content = content; // Message text
      this.threadId = threadId; // Optional thread ID
      this.timestamp = timestamp; // Message timestamp
    }
  
    /**
     * Static method to create a ChatMessage instance from JSON data.
     * @param {Object} json - The JSON object containing message data.
     * @returns {ChatMessage} - A ChatMessage instance.
     */
    static fromJson(json) {
      if (!json || typeof json !== 'object') {
        throw new Error('Invalid JSON for ChatMessage');
      }
  
      return new ChatMessage({
        role: json.role,
        content: json.content || '',
        threadId: json.threadId || null,
        timestamp: json.timestamp || new Date().toISOString(),
      });
    }
  
    /**
     * Method to convert the ChatMessage instance back to JSON.
     * @returns {Object} - JSON representation of the ChatMessage.
     */
    toJson() {
      return {
        role: this.role,
        content: this.content,
        threadId: this.threadId,
        timestamp: this.timestamp,
      };
    }
  }